import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import $appConfig from "servicestack/config";

export default class SwatchScanController {
	constructor($rootScope, $window) {
		let $ctrl = this;
		basicController(this);
		$ctrl.checkSwatchBusy = false;
		$ctrl.$window = $window;
		const id = $ctrl.countId;
		$ctrl.bus = new ServiceBus();
		$ctrl.$appConfig = $appConfig;
		$ctrl.loadSound();
		$ctrl.$rootScope = $rootScope;
	}
	loadSound() {
		let $ctrl = this;
		if (!$ctrl.errorSound) {
			$ctrl.errorSound = new Audio("/sounds/invalid_item.mp3");
			$ctrl.errorSound.load();
		}
		if (!$ctrl.successSound) {
			$ctrl.successSound = new Audio("/sounds/scan_success.mp3");
			$ctrl.successSound.load();
		}
		if (!$ctrl.dupSound) {
			$ctrl.dupSound = new Audio("/sounds/duplicate_item.mp3");
			$ctrl.dupSound.load();
		}
	}
	checkSwatch() {
		let $ctrl = this;
		$ctrl.checkSwatchBusy = true;
		$ctrl.lastScan = $ctrl.scanId;
		setTimeout(function () {
			return $ctrl.bus
				.send($ctrl.count.countType.toUpperCase() == "STOCK" ? "CheckStock" : "CheckSwatch", {
					swatchId: $ctrl.scanId,
					productId: $ctrl.scanId,
					countId: $ctrl.countId,
				})
				.then(function (response) {
					if (response.data.status.toUpperCase() === "ACTIVE" || response.data.status.toUpperCase() === "COUNTED") {
						if (window.innerWidth > 800 && window.innerHeight > 600) {
							$ctrl.successSound = new Audio("/sounds/scan_success.mp3");
							$ctrl.successSound.load();
						}
						$ctrl.successSound.play();
					} else if (response.data.status.toUpperCase() === "DUPLICATE") {
						if (window.innerWidth > 800 && window.innerHeight > 600) {
							$ctrl.dupSound = new Audio("/sounds/duplicate_item.mp3");
							$ctrl.dupSound.load();
						}
						$ctrl.dupSound.play();
					} else {
						if (window.innerWidth > 800 && window.innerHeight > 600) {
							$ctrl.errorSound = new Audio("/sounds/invalid_item.mp3");
							$ctrl.errorSound.load();
						}
						$ctrl.errorSound.play();
					}
					$ctrl.checkSwatchBusy = false;
					$ctrl.status = response.data.status;
					$ctrl.onList = response.data.onList;
					$ctrl.swatch = response.data.swatch || response.data.product;
					$ctrl.$rootScope.$broadcast("swatchScanned");
					//$ctrl.summaryQuery.load(true);
					//$ctrl.exceptionQuery.load(true);
					$ctrl.scanId = "";
					$ctrl.setFocus();
				});
		}, 250);
	}
	printBarcode(barcode) {
		let $ctrl = this;
		$ctrl.bus.send("RequestSwatchCountLineBarcode.json", {
			CountId: $ctrl.count.id,
			SwatchId: $ctrl.swatch.id,
			NeedsBarcode: barcode
		}).then(function(res) {
			$ctrl.swatch.needsBarcode = res.data.needsBarcode;
			$ctrl.$rootScope.$broadcast("swatchScanned");
		});
	}
	setFocus() {
		let $ctrl = this;
		$ctrl.$broadcast("swatch-scan-input", $ctrl);
		setTimeout(function () {
			var element = $ctrl.$window.document.getElementById("item");
			if (element) {
				element.focus();
			}
		}, 500);
	}
}
